module.exports = __webpack_public_path__ + "static/img/qd_banner.52eb8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/qd_banner.png
// module id = QzcN
// module chunks = 1